import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar';

import Routes from './Routes';
import Loader from './shared/components/loader/Loader';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'


import './App.scss';

export const queryClient = new QueryClient();

class App extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <Loader>
          <LoadingBar
            style={{
              zIndex: 10000,
              backgroundColor: '#3f51b5',
              height: '5px',
            }}
          />
          <Routes />
        </Loader>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    );
  }
}

export default process.env.NODE_ENV === 'development'
  ? hot(withRouter(App))
  : withRouter(App);
